module.exports = __webpack_public_path__ + "img/intentalo.5cb3247e.png";